export const selectEmployeeLicenceType = {
    bindings: {
        identifier: '@'
    },
    template: require('./select-employee-licence-type.html'),
    controller: 'SelectEmployeeLicenceTypeController'
};
